// Numeric blur-patch parsing shared by the inline-edit pricing tabs
// (extracted from Packages.tsx's patchNumber). Inputs are uncontrolled
// (defaultValue), so a cleared non-nullable field is a no-op and the
// display is restored rather than saving 0.
export function parseNumberInput(
    raw: string,
    current: unknown,
    opts: { nullable?: boolean; integer?: boolean } = {},
    input?: HTMLInputElement | HTMLTextAreaElement | null
): { skip: true } | { value: number | null } {
    if (raw === "") {
        if (opts.nullable) {
            return current === null || current === undefined ? { skip: true } : { value: null };
        }
        if (input) input.value = current === null || current === undefined ? "" : String(current);
        return { skip: true };
    }
    const v = Number(raw);
    if (opts.integer ? !Number.isInteger(v) || v < 0 : !Number.isFinite(v)) return { skip: true };
    if (current !== null && current !== undefined && v === Number(current)) return { skip: true };
    return { value: v };
}
